// import { baseUrl, headers, jwtHeaders, logoutUtil } from "../common/data";
import { baseUrl, jwtHeaders, logoutUtil } from "../common/data";

export const fetchAllClients = async ({ limit }) => {
    const response = await fetch(`${baseUrl}/api/client/getallclients?limit=${limit}`, {
        method: "GET",
        headers: jwtHeaders(),
        redirect: "follow",
    });

    if (response?.status === 401) {
        logoutUtil();
    }
    const resData = await response?.json();
    // console.log('all carts data=================================================>', resData);
    return resData;
};

export const createClient = async (data) => {
    
        const response = await fetch(`${baseUrl}/api/client/create`, {
            method: 'POST',
            body: data,
            // headers: headers
            headers:jwtHeaders(),
        })
        const resData = await response?.json();
        // console.log('client add data=================================================>', resData);
        return resData;
    
};

export const deleteClient = async (data) => {
    
        const response = await fetch(`${baseUrl}/api/client/deleteclient/${data}`, {
            method: 'DELETE',
            // headers: headers,
            headers:jwtHeaders(),
        })
        const resData = await response?.json();
        // console.log('client delete data=================================================>', resData);
        return resData;
    
};